import { useSelector } from 'javascripts/store';

export type CurrentUser = {
  active: boolean;
  affiliate_url: string;
  company_id: number;
  created_at: string;
  email_address: string;
  first_name: string;
  full_name: string;
  id: number;
  intercom_authentication_codes: {
    android: string;
    ios: string;
    web: string;
  };
  last_name: string;
  node_id: string;
  owner: boolean;
  permissions: number[];
  phone_number: string;
  user_role: string;
  user_type: number;
  profile_url_web: string;
  referral_link: string;
  corporate_portal_access: boolean;
};

export default function useCurrentUser() {
  const currentUser: CurrentUser = useSelector((state) => state.user);
  return currentUser;
}
